module.exports = __webpack_public_path__ + "img/card-check.59bf5217.png";